import cn from "classnames";
import Checkbox from "components/shared/checkbox";
import { featureModuleTypesEnum, userMessageTypes, userMessageTypesEnum } from "helpers/enums";
import { enumLabel } from "helpers/system";
import union from "lodash/union";
import without from "lodash/without";
import Tooltip from "rc-tooltip";
import React, { useState } from "react";
import { Popover } from "react-tiny-popover";

const ChatFilters = (props) => {
    const [openedPopover, setOpenedPopover] = useState();
    const params = props.params || { filter: {} };
    const filter = params.filter || {};
    const showFileFilter = props.showFileFilter === true;
    const showOnlyMyMessages = props.showOnlyMyMessages === true;
    const showTypeFilters = props.showTypeFilters !== false;
    const showOtherFilters = showFileFilter || showOnlyMyMessages;
    const onlyMyMessages = props.onlyMyMessages === true;
    const togglePopover = (type) => setOpenedPopover(openedPopover === type ? undefined : type);
    const hasWaybills = (props.profile?.availableFeatureModules || []).includes(featureModuleTypesEnum.Waybills);
    const lifeCycleTypes = [
        userMessageTypesEnum.BidStart,
        userMessageTypesEnum.BidApproved,
        userMessageTypesEnum.DriverControlPoints,
    ];
    const deviationTypes = [
        userMessageTypesEnum.BidLateness,
        userMessageTypesEnum.BidPointLateness,
        userMessageTypesEnum.TrackerLogsStopped,
        userMessageTypesEnum.CarStopped,
        userMessageTypesEnum.RouteEvents,
        userMessageTypesEnum.AxisLoadMonitoring,
        userMessageTypesEnum.CarStaysAtBidPoint,
        userMessageTypesEnum.BidAcceptLateness,
        userMessageTypesEnum.TemperatureMonitoring,
    ];
    const fuelPlanningTypes = [
        userMessageTypesEnum.BidRefuelingPointArrival,
        userMessageTypesEnum.BidPlannedRefuelings,
        userMessageTypesEnum.RefuelingSkipped,
    ];
    const icons = {
        [userMessageTypesEnum.User]: {
            icon: "icon-uEA83-user-edit",
            tooltipText: "Сообщения пользователей",
        },
        [userMessageTypesEnum.System]: {
            icon: "icon-uEA0C-gear",
            tooltipText: "Системные уведомления",
        },
        ...(hasWaybills
            ? {
                  [userMessageTypesEnum.Waybills]: {
                      icon: "icon-uEAB9-usb-key",
                      tooltipText: "Электронные перевозочные документы",
                  },
              }
            : {}),
        LifeCycle: {
            icon: "icon-uEA55-bids",
            divided: true,
            nestedTypes: lifeCycleTypes,
            popover: () => {
                const allSelected = lifeCycleTypes.every(isSelected);
                return (
                    <>
                        <div
                            onClick={() => toggleAll(!allSelected, lifeCycleTypes)}
                            className={cn("chat-filter__popover-item", {
                                "chat-filter__popover-item--selected": allSelected,
                            })}
                        >
                            <div className="px-2 inline-icon">
                                <Checkbox value={allSelected} inputProps={{}} />
                            </div>
                            <div className="chat-filter__popover-item--label">Выбрать все</div>
                        </div>
                        {lifeCycleTypes.map((type) => (
                            <div
                                key={type}
                                onClick={() => filterAction(type)}
                                className={cn("chat-filter__popover-item", {
                                    "chat-filter__popover-item--selected": isSelected(type),
                                })}
                            >
                                <div className="px-2 inline-icon">
                                    <Checkbox value={isSelected(type)} inputProps={{}} />
                                </div>
                                <div className="chat-filter__popover-item--label">
                                    {enumLabel(userMessageTypes, type)}
                                </div>
                            </div>
                        ))}
                    </>
                );
            },
            tooltipText: <div>Уведомления по статусам заявки</div>,
        },
        Deviation: {
            icon: "icon-uEA86-exclamation-circle",
            divided: true,
            nestedTypes: deviationTypes,
            popover: () => {
                const allSelected = deviationTypes.every(isSelected);
                return (
                    <>
                        <div
                            onClick={() => toggleAll(!allSelected, deviationTypes)}
                            className={cn("chat-filter__popover-item", {
                                "chat-filter__popover-item--selected": allSelected,
                            })}
                        >
                            <div className="px-2 inline-icon">
                                <Checkbox value={allSelected} inputProps={{}} />
                            </div>
                            <div className="chat-filter__popover-item--label">Выбрать все</div>
                        </div>
                        {deviationTypes.map((type) => (
                            <div
                                key={type}
                                onClick={() => filterAction(type)}
                                className={cn("chat-filter__popover-item", {
                                    "chat-filter__popover-item--selected": isSelected(type),
                                })}
                            >
                                <div className="px-2 inline-icon">
                                    <Checkbox value={isSelected(type)} inputProps={{}} />
                                </div>
                                <div className="chat-filter__popover-item--label">
                                    {enumLabel(userMessageTypes, type)}
                                </div>
                            </div>
                        ))}
                    </>
                );
            },
            tooltipText: <div>Уведомления по отклонениям</div>,
        },
        FuelPlanning: {
            icon: "icon-uEA36-azs",
            divided: true,
            nestedTypes: fuelPlanningTypes,
            popover: () => {
                const allSelected = fuelPlanningTypes.every(isSelected);
                return (
                    <>
                        <div
                            onClick={() => toggleAll(!allSelected, fuelPlanningTypes)}
                            className={cn("chat-filter__popover-item", {
                                "chat-filter__popover-item--selected": allSelected,
                            })}
                        >
                            <div className="px-2 inline-icon">
                                <Checkbox value={allSelected} inputProps={{}} />
                            </div>
                            <div className="chat-filter__popover-item--label">Выбрать все</div>
                        </div>
                        {fuelPlanningTypes.map((type) => (
                            <div
                                key={type}
                                onClick={() => filterAction(type)}
                                className={cn("chat-filter__popover-item", {
                                    "chat-filter__popover-item--selected": isSelected(type),
                                })}
                            >
                                <div className="px-2 inline-icon">
                                    <Checkbox value={isSelected(type)} inputProps={{}} />
                                </div>
                                <div className="chat-filter__popover-item--label">
                                    {enumLabel(userMessageTypes, type)}
                                </div>
                            </div>
                        ))}
                    </>
                );
            },
            tooltipText: <div>Уведомления по заправкам</div>,
        },
        [userMessageTypesEnum.PointVisiting]: {
            icon: "icon-uEA64-flag-finish",
            tooltipText: "Прибытие/выезд из точки",
        },
        [userMessageTypesEnum.LoadLateness]: {
            icon: "icon-uEAAF-clock",
            tooltipText: "Прогноз опоздания на загрузку",
        },
        [userMessageTypesEnum.ServicePoints]: {
            icon: "icon-uEA97-wrench",
            tooltipText: "Ремонты и ТО",
        },
    };

    const filteredTypes = filter.type?.in || Object.values(userMessageTypesEnum);
    const isSelected = (type) => filteredTypes.includes(type);
    const toggleAll = (needSelect, values) => {
        const newValue = needSelect ? union(filteredTypes, values) : without(filteredTypes, ...values);
        if (newValue.length === Object.values(userMessageTypesEnum).length) {
            const nextFilter = { ...filter };
            delete nextFilter.type;
            props.filterItems({ ...params, filter: nextFilter });
        } else {
            props.filterItems({ ...params, filter: { ...filter, type: { in: newValue } } });
        }
    };
    const filterAction = (type) => {
        if (isSelected(type) && filteredTypes.length === 1) {
            return;
        }
        const newValue = isSelected(type) ? filteredTypes.filter((item) => item !== type) : filteredTypes.concat(type);
        if (newValue.length === Object.values(userMessageTypesEnum).length) {
            const nextFilter = { ...filter };
            delete nextFilter.type;
            props.filterItems({ ...params, filter: nextFilter });
        } else {
            props.filterItems({ ...params, filter: { ...filter, type: { in: newValue } } });
        }
    };
    const onlyMessagesWithFiles = filter.fileIds !== undefined;
    const toggleMessagesWithFiles = () => {
        const nextFilter = { ...filter };
        if (onlyMessagesWithFiles) {
            delete nextFilter.fileIds;
        } else {
            nextFilter.fileIds = { ne: null };
        }
        props.filterItems({ ...params, filter: nextFilter });
    };
    const toggleOnlyMyMessages = () => props.onOnlyMyMessagesChange?.(!onlyMyMessages);
    return (
        <div className={cn("chat-filter", { "chat-filter--static": props.positionStatic })}>
            {showTypeFilters && (
                <div
                    className={cn("chat-filter__type-filters", {
                        "flex-grow-1": showOtherFilters,
                    })}
                    role="group"
                    aria-label="Фильтры по типу сообщения"
                >
                    {Object.entries(icons).map(([type, data]) => {
                        return data.divided ? (
                            <Popover
                                key={type}
                                isOpen={openedPopover === type}
                                positions={["bottom", "right"]}
                                content={data.popover()}
                                onClickOutside={() => togglePopover(type)}
                                containerClassName="popover p-0"
                            >
                                <div className="d-inline-block">
                                    <Tooltip
                                        overlay={data.tooltipText}
                                        placement="top"
                                        overlayClassName="chat-filter__tooltip"
                                        onClick={() => togglePopover(type)}
                                    >
                                        <i
                                            className={cn("chat-filter__item", {
                                                [data.icon]: true,
                                                "chat-filter__item--active": data.nestedTypes.every(isSelected),
                                                "chat-filter__item--nested-active": data.nestedTypes.some(isSelected),
                                            })}
                                        />
                                    </Tooltip>
                                </div>
                            </Popover>
                        ) : (
                            <Tooltip
                                key={type}
                                overlay={data.tooltipText}
                                placement="top"
                                overlayClassName="chat-filter__tooltip"
                            >
                                <i
                                    onClick={filterAction.bind(this, type)}
                                    className={cn("chat-filter__item", {
                                        [data.icon]: true,
                                        "chat-filter__item--active": isSelected(type),
                                    })}
                                />
                            </Tooltip>
                        );
                    })}
                </div>
            )}
            {showOtherFilters && (
                <div
                    className="chat-filter__other-filters d-flex align-items-center flex-shrink-0 ml-auto"
                    role="group"
                    aria-label="Другие фильтры"
                >
                    {showOnlyMyMessages && (
                        <button
                            type="button"
                            onClick={toggleOnlyMyMessages}
                            aria-pressed={onlyMyMessages}
                            className={cn("btn b-filter__tag--wrap mb-0", {
                                "b-filter__tag--wrap-selected": onlyMyMessages,
                            })}
                        >
                            {onlyMyMessages ? (
                                <span className="b-filter__tag--delete" aria-hidden="true" />
                            ) : (
                                <span className="b-filter__tag--checkbox" aria-hidden="true" />
                            )}
                            <span className="b-filter__tag--text">Только мои сообщения</span>
                        </button>
                    )}
                    {showFileFilter && (
                        <button
                            type="button"
                            onClick={toggleMessagesWithFiles}
                            aria-label="Показать только сообщения с файлами"
                            aria-pressed={onlyMessagesWithFiles}
                            className={cn("btn b-filter__tag--wrap mb-0", {
                                "b-filter__tag--wrap-selected": onlyMessagesWithFiles,
                            })}
                        >
                            {onlyMessagesWithFiles ? (
                                <span className="b-filter__tag--delete" aria-hidden="true" />
                            ) : (
                                <span className="b-filter__tag--checkbox" aria-hidden="true" />
                            )}
                            <span className="b-filter__tag--text">Только с файлами</span>
                        </button>
                    )}
                </div>
            )}
        </div>
    );
};

export default ChatFilters;
